export default __webpack_public_path__ + "static/media/THird_party_motor.0c4ac623.png";